(() => {
  if (window.leDetoxStoryMedia) return;
  window.leDetoxStoryMedia = true;

  const mobile = window.matchMedia('(max-width: 767px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const updateControls = (video) => {
    const variant = video.closest('.story-media-variant');
    const play = variant?.querySelector('[data-story-play]');
    const sound = variant?.querySelector('[data-story-sound]');
    if (play) {
      play.textContent = video.paused ? 'Play' : 'Pause';
      play.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
    }
    if (sound) {
      sound.textContent = video.muted ? 'Sound on' : 'Sound off';
      sound.setAttribute('aria-label', video.muted ? 'Turn sound on' : 'Turn sound off');
    }
  };

  const syncVideos = () => {
    document.querySelectorAll('.story-media-variant video').forEach((video) => {
      const isMobile = video.closest('.story-media-variant--mobile') !== null;
      const active = isMobile === mobile.matches;
      if (!active || reducedMotion.matches) {
        video.pause();
      } else if (video.dataset.storyPaused !== 'true') {
        video.play().catch(() => updateControls(video));
      }
      updateControls(video);
    });
  };

  document.addEventListener('click', (event) => {
    const control = event.target.closest('[data-story-play], [data-story-sound]');
    if (!control) return;
    const video = control.closest('.story-media-variant')?.querySelector('video');
    if (!video) return;
    if (control.matches('[data-story-play]')) {
      if (video.paused) {
        video.dataset.storyPaused = 'false';
        video.play().catch(() => updateControls(video));
      } else {
        video.dataset.storyPaused = 'true';
        video.pause();
      }
    } else {
      video.muted = !video.muted;
    }
    updateControls(video);
  });

  document.addEventListener('play', (event) => {
    if (event.target.matches('.story-media-variant video')) updateControls(event.target);
  }, true);
  document.addEventListener('pause', (event) => {
    if (event.target.matches('.story-media-variant video')) updateControls(event.target);
  }, true);
  document.addEventListener('volumechange', (event) => {
    if (event.target.matches('.story-media-variant video')) updateControls(event.target);
  }, true);

  mobile.addEventListener('change', syncVideos);
  reducedMotion.addEventListener('change', syncVideos);
  document.addEventListener('shopify:section:load', syncVideos);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncVideos, { once: true });
  } else {
    syncVideos();
  }
})();
